import { render, staticRenderFns } from "./DbInitModal.vue?vue&type=template&id=ea1d3732&scoped=true&"
import script from "./DbInitModal.vue?vue&type=script&lang=js&"
export * from "./DbInitModal.vue?vue&type=script&lang=js&"
import style0 from "./DbInitModal.vue?vue&type=style&index=0&id=ea1d3732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1d3732",
  null
  
)

export default component.exports